import PrimaryLoadingSpinner from '~/src/components/molecules/PrimaryLoadingSpinner'
import CenterPage from '~/src/components/templates/CenterPage'

const Loading = () => {
  return (
    <CenterPage>
      <PrimaryLoadingSpinner />
    </CenterPage>
  )
}

export default Loading
